export const resetCustoms = (setValues, setData, valuesInit, dataInit) => {
  setValues((prev) => ({
    ...prev,
    generaldutyimp: valuesInit.generaldutyimp,
    additionaldutyimp: valuesInit.additionaldutyimp,
    harborfeepct: valuesInit.harborfeepct,
    merchprocfeepct: valuesInit.merchprocfeepct,
    flatfee: valuesInit.flatfee,
    tsca: valuesInit.tsca,
    isf: valuesInit.isf,
  }));
  setData((prev) => ({
    ...prev,
    generaldutyimp: dataInit.generaldutyimp,
    additionaldutyimp: dataInit.additionaldutyimp,
    harborfeepct: dataInit.harborfeepct,
    merchprocfeepct: dataInit.merchprocfeepct,
    flatfee: dataInit.flatfee,
    tsca: dataInit.tsca,
    isf: dataInit.isf,
  }));
};

export const resetInbound = (setValues, setData, valuesInit, dataInit) => {
  setValues((prev) => ({
    ...prev,
    ["inpayload"]: valuesInit.inpayload,
    ["indrayage"]: valuesInit.indrayage,
    ["unloading"]: valuesInit.unloading,
    ["incollectcharges"]: valuesInit.incollectcharges,
    ["inboundothers"]: valuesInit.inboundothers,
  }));
  setData((prev) => ({
    ...prev,
    ["inpayload"]: dataInit.inpayload,
    ["indrayage"]: dataInit.indrayage,
    ["unloading"]: dataInit.unloading,
    ["incollectcharges"]: dataInit.incollectcharges,
    ["inboundothers"]: dataInit.inboundothers,
  }));
};

export const resetOutbound = (
  values,
  data,
  setValues,
  setData,
  valuesInit,
  dataInit,
  currentEdits,
  editID,
  setEditID
) => {
  const fieldnames = ["outdrayage", "loading", "outcollectcharges", "outboundothers", "outpayload"];
  const figuretypes = ["currency", "currency", "currency", "currency"];
  fieldnames.forEach((field, i) => {
    currentEdits.current.push({
      editID: editID,
      name: field,
      value: values[field],
      num: data[field],
      figuretype: figuretypes[i],
    });
    setEditID((prev) => prev + 1);
  });

  console.log(currentEdits.current);

  setValues((prev) => ({
    ...prev,
    ["outpayload"]: valuesInit.outpayload,
    ["outdrayage"]: valuesInit.outdrayage,
    ["loading"]: valuesInit.loading,
    ["outcollectcharges"]: valuesInit.outcollectcharges,
    ["outboundothers"]: valuesInit.outboundothers,
  }));
  setData((prev) => ({
    ...prev,
    ["outpayload"]: dataInit.outpayload,
    ["outdrayage"]: dataInit.outdrayage,
    ["loading"]: dataInit.loading,
    ["outcollectcharges"]: dataInit.outcollectcharges,
    ["outboundothers"]: dataInit.outboundothers,
  }));
};

export const resetOceanfreight = (setValues, setData, valuesInit, dataInit) => {
  setValues((prev) => ({
    ...prev,
    ["oceanpayload"]: valuesInit.oceanpayload,
    ["oceanfreight"]: valuesInit.oceanfreight,
  }));
  setData((prev) => ({
    ...prev,
    ["oceanpayload"]: dataInit.oceanpayload,
    ["oceanfreight"]: dataInit.oceanfreight,
  }));
};
